import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProcessingService {
  private counter = 0;
  private processingSubject = new BehaviorSubject<boolean>(false);
  isProcessing$ = this.processingSubject.asObservable();

  /** mark the start of a job */
  start() {
    this.counter++;
    if (this.counter > 0) {
      this.processingSubject.next(true);
    }
  }

  /** mark the end of a job */
  stop() {
    if (this.counter > 0) {
      this.counter--;
    }
    if (this.counter === 0) {
      this.processingSubject.next(false);
    }
  }

  /** force stop (useful for cleanup) */
  reset() {
    this.counter = 0;
    this.processingSubject.next(false);
  }
}
